<div class="page-container p-5">
  <div class="row px-5 py-4">
    <div class="form-container w-100 mx-lg-auto">
      <div class="col-12 d-flex justify-content-between align-items-end px-0 pb-3">
        <h6 class="mb-2">Create A Product</h6>
        <a [routerLink]="['/products/home']" [queryParams]="utilitiesService.buildQueryParams(activatedRoute)" 
          class="btn btn-secondary d-inline-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left mr-2" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 
              8.5H14.5A.5.5 0 0 0 15 8z"></path>
          </svg>
          Back to product search
        </a>
      </div>
      <div class="my-alert m-0 p-3 p-md-5">
        <app-smart-view *ngIf="this.formGroup" [mode]="mode" [formGroup]="this.formGroup" [fb]="fb" [isBusy]="isBusy"
          [overridePersmission]="true" [permissionUpdate]="permissionUpdate" [permissionCreate]="permission"
          [silentLoading]="silentLoading" (resetEvent)="reset()" (submitEvent)="submit()" (closeEmitter)="closeModal()"
          [resetCaption]="'Reset Product'" [saveCaption]="'Create Product'" [buttonContainerRequired]="true"
          [smartViewUsedInForm]="true" [removeResetButton]="true">
          <div class="mb-5">

            <div class="pb-3">
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-text-box-with-dropdown [permission]="permission" [control]="this.formGroup.controls.partNumber"
                  [labelBlock]="true" [idName]="'part-number'" [label]="'Part Number:'" [maxLength]="18" [dropdownType]="'product-prefixes'">
                </lib-text-box-with-dropdown>
              </div>
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-text-box [permission]="permission" [control]="this.formGroup.controls.englishShortTitle"
                  [labelBlock]="true" [idName]="'english-short-title'" [label]="'English Short Title:'" [maxLength]="20">
                </lib-text-box>
              </div>
            </div>

            <div class="pb-3">
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-select-box [permission]="permission" [idField]="'code'" [source]="countries"
                  [control]="this.formGroup.controls.countryOfOriginCode" [labelBlock]="true" [idName]="'country'"
                  [label]="'Country of Origin:'">
                </lib-select-box>
              </div>
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-select-box [permission]="permission" [control]="this.formGroup.controls.masterProductSatus"
                  [source]="masterProductSatuses" [labelBlock]="true" [idName]="'masterProductStatus'"
                  [label]="'Master Product Status:'">
                </lib-select-box>
              </div>
              <div class="col-12 col-lg-5 px-0 filter-item">
                <lib-select-box [permission]="permission" [control]="this.formGroup.controls.componentStatus"
                  [source]="componentStatuses" [labelBlock]="true" [idName]="'componentStatus'"
                  [label]="'Component Status:'">
                </lib-select-box>
              </div>
              <div class="col-12 col-lg-5 px-0 filter-item">
                <lib-number-box [permission]="permission" [control]="this.formGroup.controls.ukCommodityCode"
                  [labelBlock]="true" [idName]="'uk-commodity-code'" [label]="'UK Commodity Code:'">
                </lib-number-box>
              </div>
              <div class="col-12 col-lg-5 px-0 filter-item">
                <lib-number-box [permission]="permission" [control]="this.formGroup.controls.usCommodityCode"
                  [labelBlock]="true" [idName]="'us-commodity-code'" [label]="'US Commodity Code:'">
                </lib-number-box>
              </div>
            </div>

            <div>
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-select-box [permission]="permission" [fieldDescription]="'title'"
                  [control]="this.formGroup.controls.productType" [source]="productTypes | addTitleToProductType" [labelBlock]="true"
                  [idName]="'productType'" [label]="'Product Type:'">
                </lib-select-box>
              </div>
              <div class="col-12 col-lg-8 px-0 filter-item">
                <lib-modal-type-input [permission]="permission" [idField]="'code'" [control]="this.formGroup.controls.taxonomyCode"
                  [source]="taxonomies" [labelBlock]="true" [idName]="'taxonomyCode'" [placeHolder]="'Click to look up for taxonomy'"
                  [label]="'Taxonomy Code:'">
                </lib-modal-type-input>
              </div>
              <div class="col-12 col-lg-5 px-0 filter-item">
                <lib-select-box [permission]="permission" [idField]="'code'" [control]="this.formGroup.controls.taxRateCategory"
                  [source]="taxRateCategories" [labelBlock]="true" [idName]="'taxRateCategory'"
                  [label]="'Tax Rate Category:'">
                </lib-select-box>
              </div>
              <div class="col-12 col-lg-5 px-0 filter-item">
                <lib-select-box [permission]="permission" [control]="this.formGroup.controls.discountCategories"
                  [source]="discountCategories" [labelBlock]="true" [idName]="'discountCategory'"
                  [label]="'Discount Category:'">
                </lib-select-box>
              </div>
            </div>
          </div>
        </app-smart-view>
      </div>
    </div>
  </div>
</div>